import {
	DesignObjectType,
	RequirementResultType,
	RequirementResultTypeDisplayNames,
} from '@cadstrom/sigma-engine-shared';

import { ComponentFunctionDetailPanel } from './result-detail-panels/component-function-detail-panel.js';
import { ComponentLimitsDetailPanel } from './result-detail-panels/component-limits-detail-panel.js';
import { ComponentValidationDetailPanel } from './result-detail-panels/component-validation-detail-panel.js';
import { LogicalBusDetailPanel } from './result-detail-panels/logical-bus-detail-panel.js';
import { NetDriveDetailPanel } from './result-detail-panels/net-drive-detail-panel.js';
import { PinoutDetailPanel } from './result-detail-panels/pinout-detail-panel.js';

import type { ModelWithNetStats, RequirementInstanceResult } from '@cadstrom/sigma-engine-shared';
import type { GridRowModel } from '@mui/x-data-grid-premium';
import type React from 'react';

const analysisTypes = {
	[RequirementResultType.NetDrive]: {
		name: RequirementResultTypeDisplayNames[RequirementResultType.NetDrive],
		type: DesignObjectType.Net,
		enabled: true,
		detailPanel: NetDriveDetailPanel,
	},
	[RequirementResultType.Pinout]: {
		name: RequirementResultTypeDisplayNames[RequirementResultType.Pinout],
		type: DesignObjectType.Module,
		enabled: true,
		detailPanel: PinoutDetailPanel,
	},
	[RequirementResultType.BNDS]: {
		name: RequirementResultTypeDisplayNames[RequirementResultType.BNDS],
		type: DesignObjectType.Module,
		enabled: true,
		detailPanel: ComponentLimitsDetailPanel,
	},
	[RequirementResultType.CVAL]: {
		name: RequirementResultTypeDisplayNames[RequirementResultType.CVAL],
		type: DesignObjectType.Module,
		enabled: true,
		detailPanel: ComponentValidationDetailPanel,
	},
	[RequirementResultType.LogicalBus]: {
		name: RequirementResultTypeDisplayNames[RequirementResultType.LogicalBus],
		type: DesignObjectType.Net,
		enabled: true,
		detailPanel: LogicalBusDetailPanel,
	},
	[RequirementResultType.ComponentFunction]: {
		name: RequirementResultTypeDisplayNames[RequirementResultType.ComponentFunction],
		type: DesignObjectType.Module,
		enabled: true,
		detailPanel: ComponentFunctionDetailPanel,
	},
	[RequirementResultType.ComponentResource]: {
		name: RequirementResultTypeDisplayNames[RequirementResultType.ComponentResource],
		type: DesignObjectType.Module,
		enabled: true,
		detailPanel: ComponentFunctionDetailPanel,
	},
} satisfies Partial<
	Record<
		RequirementResultType,
		{
			name: string;
			type: DesignObjectType;
			enabled: boolean;
			detailPanel?: React.ComponentType<{
				row: GridRowModel<RequirementInstanceResult>;
				loading?: boolean;
				projectModel: ModelWithNetStats;
				handleAddModuleFilter: (moduleReferenceDesignator: string) => void;
			}>;
		}
	>
>;

// Get all enabled analysis types as an array
const enabledAnalysisTypes = Object.values(RequirementResultType).filter(
	(type) => analysisTypes[type].enabled ?? false,
);

export { analysisTypes, enabledAnalysisTypes };
